var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermsAndCondition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.507,15.325l-3.73-.462V12.635a1.965,1.965,0,0,1,.642-1.368A4.794,4.794,0,0,0,16.86,7.833a4.861,4.861,0,0,0-9.64-.89,4.805,4.805,0,0,0,1.286,4.249,2.307,2.307,0,0,1,.717,1.563v2.1l-3.73.467a2.084,2.084,0,0,0-1.825,2.066v2.94a.7.7,0,0,0,.694.7H19.638a.7.7,0,0,0,.694-.7v-2.94A2.084,2.084,0,0,0,18.507,15.325ZM8.587,7.187a3.473,3.473,0,0,1,6.885.646,3.418,3.418,0,0,1-1.028,2.446,3.334,3.334,0,0,0-1.055,2.356v2.142H10.611V12.755A3.622,3.622,0,0,0,9.5,10.224,3.433,3.433,0,0,1,8.587,7.187Zm10.357,12.45H5.057V17.391a.694.694,0,0,1,.608-.688l4.252-.538h4.124l4.294.538a.7.7,0,0,1,.609.688Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsAndCondition);
export default __webpack_public_path__ + "static/media/terms_and_condition.15608e435d5c0cf031fbd8f3744d801e.svg";
export { ForwardRef as ReactComponent };